import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { CookieConsent } from './components/CookieConsent';
import { Toaster } from './components/ui/sonner';
import './index.css';
import { BASE, isApiError } from './lib/api';
import { AuthProvider } from './lib/auth';
import { BrandingProvider } from './lib/branding';
import { primeHostTenant } from './lib/tenant';
import { ThemeProvider } from './lib/theme';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      refetchOnWindowFocus: false,
      retry: (count, err) => {
        if (isApiError(err) && err.status < 500) return false;
        return count < 2;
      },
    },
  },
});

// On a custom host, learn which tenant it belongs to (a sign-in domain set in the console) before anything
// asks for branding or a session. Resolves at once on localhost, on a cached answer, and within 2.5 s otherwise.
void primeHostTenant(BASE).finally(() =>
  createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <BrandingProvider>
        <QueryClientProvider client={queryClient}>
          <AuthProvider>
            <App />
            <Toaster />
            <CookieConsent />
          </AuthProvider>
        </QueryClientProvider>
      </BrandingProvider>
    </ThemeProvider>
  </StrictMode>,
  ),
);
